"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageHeaderNavigation = exports.PageHeaderNavigationDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_active_person_1 = require("../../hooks/use-active-person");
var use_icons_1 = require("../../hooks/use-icons");
var use_profile_menu_state_1 = require("../../hooks/use-profile-menu-state");
var use_modal_1 = require("../../hooks/use-modal");
var icon_1 = require("../elements/icon");
var image_bubble_1 = require("../elements/image-bubble");
var profile_menu_1 = require("./profile-menu");
var app_search_dialog_1 = require("./app-search-dialog");
var text_bubble_1 = require("../elements/text-bubble");
var initials_1 = require("../../utils/initials");
exports.PageHeaderNavigationDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    top: -1px;\n  "], ["\n    display: flex;\n    flex-direction: row;\n    top: -1px;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    top: 0px;\n  "], ["\n    top: 0px;\n  "])))
});
var ProfileButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    border: none;\n    outline: none;\n    padding: 0;\n    position: relative;\n    margin: 0;\n    cursor: pointer;\n    border: none;\n    transition: border-color 0.3s;\n    margin-right: ", ";\n\n    border-radius: 50%;\n    ", "\n\n    ", " {\n      width: 22px;\n      height: 22px;\n\n      img {\n        object-fit: cover;  \n      }\n    }\n\n  "], ["\n    border: none;\n    outline: none;\n    padding: 0;\n    position: relative;\n    margin: 0;\n    cursor: pointer;\n    border: none;\n    transition: border-color 0.3s;\n    margin-right: ", ";\n\n    border-radius: 50%;\n    ", "\n\n    ", " {\n      width: 22px;\n      height: 22px;\n\n      img {\n        object-fit: cover;  \n      }\n    }\n\n  "])), theme_1.theme.UNIT(1), function (_a) {
    var isActive = _a.isActive;
    return isActive && (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      border-color: ", ";\n    "], ["\n      border-color: ", ";\n    "])), theme_1.theme.COLOR('primary'));
  }, image_bubble_1.ImageBubble.cls.rule()),
  tablet: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\n    ", " {\n      width: 24px;\n      height: 24px;\n    }\n  "], ["\n\n    ", " {\n      width: 24px;\n      height: 24px;\n    }\n  "])), image_bubble_1.ImageBubble.cls.rule()),
  desktopLarge: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\n    ", " {\n      width: 30px;\n      height: 30px;\n    }\n  "], ["\n\n    ", " {\n      width: 30px;\n      height: 30px;\n    }\n  "])), image_bubble_1.ImageBubble.cls.rule())
});
var ProfileIconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var PhotoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var SearchButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    margin-right: ", ";\n    cursor: pointer;\n    width: 22px;\n    height: 22px;\n\n    &:hover {\n      ", ";\n    }\n  "], ["\n    margin-right: ", ";\n    cursor: pointer;\n    width: 22px;\n    height: 22px;\n\n    &:hover {\n      ", ";\n    }\n  "])), theme_1.theme.UNIT(2), theme_1.theme.FILL('primary')),
  tablet: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    width: 24px;\n    height: 24px;\n  "], ["\n    width: 24px;\n    height: 24px;\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme_1.theme.UNIT(3)),
  desktopLarge: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    width: 30px;\n    height: 30px;\n  "], ["\n    width: 30px;\n    height: 30px;\n  "])))
});
var ProfileMenuStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    position: absolute;\n    right: 0;\n    top: 50px;\n    width: 100%;\n    max-width: 320px;\n    z-index: 200;\n  "], ["\n    position: absolute;\n    right: 0;\n    top: 50px;\n    width: 100%;\n    max-width: 320px;\n    z-index: 200;\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    top: 60px;\n  "], ["\n    top: 60px;\n  "])))
});
var InitialsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    width: 22px;\n    height: 22px;\n    font-size: 10px;\n  "], ["\n    width: 22px;\n    height: 22px;\n    font-size: 10px;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    width: 24px;\n    height: 24px;\n  "], ["\n    width: 24px;\n    height: 24px;\n  "]))),
  desktopLarge: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    width: 30px;\n    height: 30px;\n  "], ["\n    width: 30px;\n    height: 30px;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  ProfileButton: styled_components_1.default.button(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), ProfileButtonStyles),
  ProfileIcon: (0, styled_components_1.default)(icon_1.Icon)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), ProfileIconStyles),
  Initials: (0, styled_components_1.default)(text_bubble_1.TextBubble)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), InitialsStyles),
  Photo: (0, styled_components_1.default)(image_bubble_1.ImageBubble)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), PhotoStyles),
  ProfileMenu: (0, styled_components_1.default)(profile_menu_1.ProfileMenu)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), ProfileMenuStyles),
  SearchButton: (0, styled_components_1.default)(icon_1.Icon)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), SearchButtonStyles)
};
var PageHeaderNavigation = function (props) {
  var className = props.className;
  var person = (0, use_active_person_1.useActivePerson)().person;
  var photo = person && person.photo && {
    id: person.photo.id,
    url: person.photo.url
  };
  var profileMenu = (0, use_profile_menu_state_1.useProfileMenuState)();
  var Icons = (0, use_icons_1.useIcons)();
  var modal = (0, use_modal_1.useModal)();
  var onProfileButtonClick = function () {
    profileMenu.toggle();
  };
  var onSearchClick = function () {
    modal.show(react_1.default.createElement(app_search_dialog_1.AppSearchDialog, null), {
      align: 'flex-start',
      hideOnOverlayClick: true
    });
  };
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.SearchButton, {
    onClick: onSearchClick
  }, react_1.default.createElement(Icons.SearchCircle, null)), react_1.default.createElement(My.ProfileButton, {
    isActive: profileMenu.isShown,
    onClick: onProfileButtonClick,
    role: "button"
  }, photo && photo.url ? react_1.default.createElement(My.Photo, {
    image: photo
  }) : react_1.default.createElement(My.Initials, null, (0, initials_1.initials)(person.name))), profileMenu.isShown && react_1.default.createElement(My.ProfileMenu, null));
};
exports.PageHeaderNavigation = PageHeaderNavigation;
exports.PageHeaderNavigation.defaultProps = exports.PageHeaderNavigationDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24;